import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";
import { ProductSearchSearch } from "client/products/types";

import { COLLECTION_PAGE_BY_KIND } from "../constants";
import { StorefrontCollectionKind } from "../types";

const paths = {
  detail: "/:slug",
};

type ProductCollectionDetailParams = {
  slug: string;
};

type ProductCollectionPathDefinitions = {
  detail: { Params: ProductCollectionDetailParams; Search: ProductSearchSearch };
};

export type ProductCollectionPaths = MakePaths<ProductCollectionPathDefinitions>;

export const useProductCollectionRoutes = (
  opts: MakeRoutesOpts,
  kind: StorefrontCollectionKind,
) => {
  return makeClientRoutes(opts, [
    {
      path: paths.detail,
      element: async () => {
        const { default: ProductCollectionPage } = await import(
          "../components/ProductCollectionPage"
        );
        return { default: () => <ProductCollectionPage kind={kind} /> };
      },
      pageName: COLLECTION_PAGE_BY_KIND[kind].pageName,
    },
  ]);
};

export const makeProductCollectionUrls = (base: string) => {
  return makeUrls<ProductCollectionPathDefinitions>(base, {
    detail: { path: paths.detail, to: ({ slug }) => `/${slug}` },
  });
};
